import styled from 'styled-components';
import BaseModal from 'antd/es/modal';

import { PaletteColor, SizeUnit } from '@utils/types';

export type StylesProps = {
  headerMediaQuery?: string;
  backgroundColor?: PaletteColor;
  padding?: SizeUnit;
};
export const StyledModal = styled(BaseModal)<StylesProps>`
  &&& {
    .setur-modal-header {
      border: none;
      ${({ theme, backgroundColor }) =>
        backgroundColor &&
        `background-color: ${theme.palette[backgroundColor]}`}
    }

    .setur-modal-content {
      padding: ${(p) => (p.padding ? p.padding : '44px')};
      ${({ theme, backgroundColor }) =>
        backgroundColor &&
        `background-color: ${theme.palette[backgroundColor]}`}
    }

    .setur-modal-body,
    .setur-modal-header {
      padding: 0;
    }

    .setur-modal-close {
      background-color: transparent;

      &:hover {
        background-color: transparent;
      }
    }

    .setur-modal-close-x {
      height: unset;
      width: unset;
      line-height: normal;
      position: absolute;
      right: 0px;
      top: 0px;
      ${({ closable }) => !closable && 'display: none;'}
    }
    ${(p) => p.headerMediaQuery ?? p.theme.mediaQueries.PHONE} {
      max-width: calc(100vw);
      min-height: 100vh;
      padding-bottom: 0;
      margin: 0;
      .setur-modal-header {
        margin-top: 60px;
        height: 35px;
      }
      .setur-modal-content {
        padding: ${(p) => (p.padding ? p.padding : '15px')};
        min-height: 100vh;
      }
      .setur-modal-body {
        margin-top: 15px;
      }
    }
    position: relative;
  }
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const CloseButtonLabel = styled.label`
  width: 45px;
  height: 23px;
  margin: 0 10px 1px 0;
  font-size: 18px;
  color: ${(p) => p.theme.palette.darkGrey};
  cursor: pointer;
  font-weight: normal;
`;
